var __jsx = React.createElement;
import { useStoreState } from "pullstate";
import React from "react";
import classNames from "classnames";
import useMedia, { MediaSizes } from "../hooks/useMedia";
import onDownloadApp from "../utils/downloadApp";
import Store from "../utils/Store";
import Button from "./common/Button";
import Modal from "./common/Modal";
import ConfigureDCMIO from "./ConfigureDCMIO";
import AwesomeIcon from "./AwesomeIcon";
import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
var ConnectModality = function ConnectModality() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        isVisible: s.isConnectModalityOpen
      };
    }),
    isVisible = _useStoreState.isVisible;
  var getIP = function getIP() {
    try {
      return window.electronAPI.getIP();
    } catch (err) {
      return "Refer to System Settings";
    }
  };
  var DesktopAppInstructions = function DesktopAppInstructions() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col justify-between h-full pt-6 pb-3 text-left"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-full pb-6 px-6"
    }, /*#__PURE__*/React.createElement("p", null, t("connection_modality.enter_message")), /*#__PURE__*/React.createElement("div", {
      className: "py-6"
    }, /*#__PURE__*/React.createElement("div", {
      className: "py-2 flex "
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-[100px] text-start"
    }, "AE Title:"), /*#__PURE__*/React.createElement("div", {
      className: "bg-gray-700 rounded text-center px-3"
    }, "QUREAI")), /*#__PURE__*/React.createElement("div", {
      className: "py-2 flex"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-[100px] text-start"
    }, "IP:"), /*#__PURE__*/React.createElement("div", {
      className: "bg-gray-700 rounded text-center px-3"
    }, getIP())), /*#__PURE__*/React.createElement("div", {
      className: "py-2 flex"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-[100px] text-start"
    }, "Port:"), /*#__PURE__*/React.createElement("div", {
      className: "bg-gray-700 rounded text-center px-3"
    }, "5253"))), /*#__PURE__*/React.createElement("div", {
      className: "text-md rounded border border-gray-700 p-4"
    }, t("connection_modality.note"), /*#__PURE__*/React.createElement("br", null), t("connection_modality.not_work")), /*#__PURE__*/React.createElement(ConfigureDCMIO, null)), /*#__PURE__*/React.createElement("div", {
      className: "px-6"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "grow-1 !px-5 py-3",
      onClick: function onClick() {
        return window.location.href = "mailto:support@qure.ai";
      }
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCircleQuestion,
      className: "w-6 mr-3"
    }), t("connection_modality.request_support"))));
  };
  var OtherInstructions = function OtherInstructions() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col justify-center items-center h-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-6 text-left text-gray-600 dark:text-gray-300"
    }, /*#__PURE__*/React.createElement("p", {
      className: "pb-5 font-normal"
    }, t("connection_modality.use_message")), /*#__PURE__*/React.createElement(ConfigureDCMIO, null)), !isMobile && /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-end border-t border-t-gray-600 w-full p-4"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        window.open("/open-app", "_blank");
      },
      className: "grow-1 px-6 py-4 hidden"
    }, t("connection_modality.launch_desktop_app")), /*#__PURE__*/React.createElement("a", {
      href: "/open-app",
      target: "_blank",
      className: "text-gray-600 dark:text-white px-4"
    }, t("installed_qure_app")), /*#__PURE__*/React.createElement(Button, {
      className: "grow-1 px-6 py-4 ml-4",
      onClick: onDownloadApp,
      isPrimary: true
    }, t("connection_modality.download_qure_app"))));
  };
  var onClose = function onClose() {
    Store.update(function (s) {
      s.isConnectModalityOpen = false;
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: isVisible,
    onClose: onClose,
    title: t("setting_connection"),
    className: classNames("w-full", {
      "sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-5/12": window.electronAPI,
      "sm:w-9/12 md:w-8/12 lg:w-4/12 xl:w-4/12": !window.electronAPI
    }),
    closeOnClickAway: true
  }, window.electronAPI ? /*#__PURE__*/React.createElement(DesktopAppInstructions, null) : /*#__PURE__*/React.createElement(OtherInstructions, null));
};
export default ConnectModality;